import TestZvukovDialog from "./TestZvukovDialog";

export default TestZvukovDialog.create({});



// WEBPACK FOOTER //
// ./src/components/common/testZvukovService/index.js